export enum AddressPrefix {
  AdminOffice = 'grAdmin',
  GranteeContact = 'grContact',
  Mailing = 'addressMailing',
  Physical = 'addressPhysical',
  ProjectDirector = 'grProjDir',
}
